import {
  GET_REPORTING_TYPE_ASSOCIATIONS, GET_REPORTING_TYPE_ASSOCIATIONS_COMPLETED, GET_REPORTING_TYPE_ASSOCIATIONS_FAILED,
  ASSOCIATE_REPORTING_TYPE, ASSOCIATE_REPORTING_TYPE_COMPLETED, ASSOCIATE_REPORTING_TYPE_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../../Auth/actions";

const defaultState = {
  reportingTypeAssociations: [],
  reportingTypeAssociationsLoading: false,
  reportingTypeAssociationsError: null,
  associatingReportType: false,
};

function regulatoryReportingTypeAssociation(state = defaultState, action) {
  switch (action.type) {
    case GET_REPORTING_TYPE_ASSOCIATIONS: {
      return {
        ...state,
        reportingTypeAssociationsLoading: true,
        reportingTypeAssociations: [],
        reportingTypeAssociationsError: null,
      };
    }
    case GET_REPORTING_TYPE_ASSOCIATIONS_COMPLETED: {
      return {
        ...state,
        reportingTypeAssociationsLoading: false,
        reportingTypeAssociations: action.payload.data,
      };
    }
    case GET_REPORTING_TYPE_ASSOCIATIONS_FAILED: {
      return {
        ...state,
        reportingTypeAssociationsLoading: false,
        reportingTypeAssociationsError: action.payload,
      };
    }
    case ASSOCIATE_REPORTING_TYPE: {
      return {
        ...state,
        associatingReportType: true,
      };
    }
    case ASSOCIATE_REPORTING_TYPE_COMPLETED: {
      return {
        ...state,
        associatingReportType: false,
      };
    }
    case ASSOCIATE_REPORTING_TYPE_FAILED: {
      return {
        ...state,
        associatingReportType: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
}

export default regulatoryReportingTypeAssociation;



// WEBPACK FOOTER //
// ./src/Dispensary/RegulatoryReporting/reducer.js